import * as React from "react"
import Svg, { Path } from "react-native-svg"

const BookingIcon = ({ size = 24, color = "#8b8989ff", ...props }) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 -960 960 960"
    fill="none"
    {...props}
  >
    <Path
      d="M680-80v-120H560v-80h120v-120h80v120h120v80H760v120h-80Zm-480-80q-33 0-56.5-23.5T120-240v-480q0-33 23.5-56.5T200-800h40v-80h80v80h240v-80h80v80h40q33 0 56.5 23.5T760-720v244q-20-3-40-3t-40 3v-84H200v320h280q0 20 3 40t11 40H200Zm0-480h480v-80H200v80Zm0 0v-80 80Z"
      fill={color}
    />
  </Svg>
)

export default BookingIcon
